"use strict";
// Copyright © 2021 Move Closer
Object.defineProperty(exports, "__esModule", { value: true });
exports.BootstrapImage = void 0;
const composition_api_1 = require("@vue/composition-api");
const _abstract_1 = require("../../_abstract");
const Image_config_1 = require("./Image.config");
const Image_hooks_1 = require("./Image.hooks");
/**
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 * @author Łukasz Sitnicki <lukasz.sitnicki@movecloser.pl>
 */
exports.BootstrapImage = composition_api_1.defineComponent({
    name: 'BootstrapImage',
    props: Image_hooks_1.bootstrapImageProps,
    emits: ['error', 'load'],
    setup(props, ctx) {
        /**
         * Source for the fallback image (in case of the main image load error).
         */
        const fallbackImage = composition_api_1.computed(() => typeof props.fallback === 'string' ? props.fallback : Image_config_1.FALLBACK_IMG_BASE64);
        /**
         * Source for the loading image (until the target image loads).
         */
        const loadingImage = composition_api_1.computed(() => typeof props.loading === 'string' ? props.loading : Image_config_1.FALLBACK_IMG_BASE64);
        const { imgAlt, imgSrc, isLoaded, onError, onLoad } = _abstract_1.useImage(props, ctx, fallbackImage.value);
        /**
         * Determine if image should be lazy loaded.
         */
        const globalLazy = composition_api_1.inject('lazyImages', true);
        const shouldBeLazy = composition_api_1.computed(() => globalLazy && props.isLazy && !isLoaded.value);
        return {
            fallbackImage,
            hasWindow: typeof window !== 'undefined',
            imgAlt,
            imgSrc,
            loadingImage,
            onError,
            onLoad,
            shouldBeLazy
        };
    },
    template: `
    <img v-if="shouldBeLazy" v-lazy="{ src:  hasWindow ? imgSrc : null, error: fallbackImage, loading: loadingImage }"
         v-bind="{ sizes, src: loadingImage, width, height }" :data-srcset="srcset" :alt="imgAlt" class="img">
    <img v-else :src="imgSrc" v-bind="{ srcset, sizes, width, height }" :alt="imgAlt"
         @error="onError" @load="onLoad" class="img">
  `
});
//# sourceMappingURL=Image.js.map